import { FC, useContext } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ErrorText } from "../../../../../../../components/billing";
import { Checkbox } from "../../../../../../../components/forms/checkbox";
import { VerificationDTO } from "../../../../../../../store/verification/models/dto/due-diligence";
import { useDueDiligenceKycType } from "../../../../../../../store/verification/models/internal";
import { mapObject } from "../../../../../../../utils/utils";
import { ConfigContext } from "../../config-context";

type FormType = VerificationDTO.Requests.DueDiligence.Form.Post.Final.T["kycRequests"][number];

export const KycTypes: FC<{}> = ({}) => {
  const DueDiligenceKycTypes = useDueDiligenceKycType();
  const { item } = useContext(ConfigContext);
  const { control } = useFormContext<FormType>();

  return (
    <Controller
      control={control}
      name="dueDiligenceKycTypes"
      render={({ field, fieldState: { error } }) => (
        <>
          {mapObject(DueDiligenceKycTypes.enum, (val, key) =>
            key === "COMPANY_MEMBER" &&
              !item.enabledOptionalFields.includes("COMPANY_MEMBERS") ? null : (
              <span key={key}>
                <Checkbox
                  label={val}
                  key={key}
                  checked={(field.value || []).includes(key)}
                  onChange={(e) => {
                    field.onChange(
                      e.target.checked
                        ? [...(field.value || []), key]
                        : (field.value || []).filter((y) => y !== key)
                    );
                  }}
                />
              </span>
            )
          )}
          {error ? <ErrorText>{error.message}</ErrorText> : null}
        </>
      )}
    />
  );
};
